class SpecialSlider {
	constructor(props) {
		const container = document.querySelector(props);

		if (container) {
			this.elements = {
				container: container,
				stars: [...container.querySelectorAll('.special-image-container .star')],
				stones: [...container.querySelectorAll('.special-image-container .stone')],
				ring: [...container.querySelectorAll('.special-image-container .ring-center')],
			};

			this.animation = {
				delayMax: 10,
				delayMin: 5,
				durationMax: 700,
				durationMin: 400,
			};

			this.init();
		}
	}

	init() {
		this.animationDelay(this.elements.stars, 'animation');
		this.animationDelay(this.elements.stones, 'transition');

		if (window.innerWidth > 991) {
			this.mouseHoverEvent();
		}
	}

	random(max, min) {
		return Math.floor(Math.random() * (max - min) + min);
	}

	animationDelay(items, choice) {
		items.forEach((item) => {
			if (choice === 'animation') {
				item.style.animationDelay = `${this.random(this.animation.delayMax, this.animation.delayMin)}s`;
			}
			if (choice === 'transition') {
				item.style.transition = `${this.random(this.animation.durationMax, this.animation.durationMin)}ms linear`;
			}
		});
	}

	mouseHoverEvent() {
		const {stones, ring, container} = this.elements;
		container.addEventListener('mousemove', (e) => {
			let x = e.clientX / window.innerWidth,
				y = e.clientY / window.innerWidth;

			stones.forEach((el, index) => {
				if (index % 2 === 1) {
					el.style.transform = `translate(${-x * 50}px, ${y * 50}px)`;
				} else {
					el.style.transform = `translate(${x * 50}px, ${-y * 50}px)`;
				}
			});
		});
	}
}


new SpecialSlider('.section.slider');